import { render, staticRenderFns } from "./recommendedProducts.vue?vue&type=template&id=21806071&scoped=true&"
import script from "./recommendedProducts.vue?vue&type=script&lang=js&"
export * from "./recommendedProducts.vue?vue&type=script&lang=js&"
import style0 from "./recommendedProducts.vue?vue&type=style&index=0&id=21806071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21806071",
  null
  
)

export default component.exports